export default function nowPlayingMetadata(metadata) {
  let mediaSession = {
    artist: undefined,
    title: undefined,
    album: undefined,
    artwork: undefined,
  };

  mediaSession.artwork = [
    {
      src: metadata.imageSource?.medium_square?.url,
    },
  ];

  if (metadata.itemType === 'track') {
    mediaSession.artist = metadata.track?.artistName;
    mediaSession.title = metadata.track?.title;
    mediaSession.album = metadata.track?.releaseName;
  } else if (metadata.itemType === 'note') {
    mediaSession.artist = metadata.track?.artistName;
    mediaSession.title = metadata.track?.title;
    mediaSession.album = metadata.track?.releaseName;
  } else if (metadata.show) {
    mediaSession.title = metadata.show?.title;
  } else if (metadata.station) {
    mediaSession.title = metadata.station?.callSign
  }

  return mediaSession;
}
